export default "__VITE_ASSET__D_f2Muo7__"